import { Link } from '@remix-run/react';
import { format } from 'date-fns';
import logo from '~/assets/Logo.svg';
import ErrorView from '~/components/errors/error';
import { LegalLinks, SocialLinks } from '~/components/footer/footer';
import { MobileMenuProvider } from '~/components/navbar/navbar';
import useTranslation from '~/i18n/i18n';
import { metadataMeta } from '~/lib/utils/meta-utils-client';
import { metadataLoader } from '~/lib/utils/meta-utils-server';

export const loader = metadataLoader((t) => ({
  title: t('common.routes.error404.title'),
  description: t('common.routes.error404.description'),
}));

export const meta = metadataMeta<typeof loader>();

export default function Error404() {
  const { t } = useTranslation();
  return (
    <MobileMenuProvider>
      <div className="flex h-full min-h-dvh w-full flex-col items-center justify-between gap-y-2 p-4 md:px-16 md:py-8">
        <div className="flex w-full grow flex-row items-center justify-start gap-16">
          <Link to="/">
            <img
              src={logo}
              alt={t('common.appName')}
              className="h-auto max-h-14 w-auto dark:invert md:h-full md:w-auto"
            />
          </Link>
        </div>

        <ErrorView
          title={t('common.errors.pageNotFoundTitle')}
          subtitle={t('common.errors.pageNotFoundSubtitle')}
          description={t('common.errors.pageNotFoundDescription')}
        />

        <div className="flex w-full flex-col gap-8 pb-16">
          <div className="flex flex-row flex-wrap items-center justify-between">
            <img
              src={logo}
              alt={t('common.appName')}
              className="h-10 w-auto dark:invert"
            />
          </div>
          <div className="flex flex-col items-end justify-between gap-3 md:flex-row">
            <div className="flex flex-row items-center gap-2 text-sm opacity-50">
              <span>
                © {format(new Date(), 'yyyy')} {t('common.appName')}
              </span>
              <LegalLinks />
            </div>
            <div className="flex flex-row items-center justify-center gap-4">
              <SocialLinks />
            </div>
          </div>
        </div>
      </div>
    </MobileMenuProvider>
  );
}
